enum Account {
  SET_ACCOUNT_INITIALIZE = 'SET_ACCOUNT_INITIALIZE',
  SET_ACCOUNT_LIST = 'SET_ACCOUNT_LIST',
  SET_ACCOUNT_INFO = 'SET_ACCOUNT_INFO'
}

export default Account;
